( function () {
	'use strict';

	function Category () {
		function link ( scope, element ) {
			function inputShouldFocus () {
				var el = element.find( 'span.add-tag-btn' );

				el.on( 'click', function () {
					el.prev( 'input' )[ 0 ].focus();
				} );
			}

			function isDisableSave () {
				scope.$watch( 'vm.collection', function ( newValue ) {
					var isSufficient = newValue.some( function ( model ) {
						return model.children.length < scope.vm.minimumTagLimit || !model.filterName;
					} );

					scope.vm.disableSave = isSufficient;
				}, true );
			}

			isDisableSave();
			inputShouldFocus();
		}

		return {
			'templateUrl'      : '/templates/components/category/category.html',
			'restrict'         : 'E',
			'link'             : link,
			'controller'       : 'CategoryController',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'model'           : '=',
				'collection'      : '=',
				'index'           : '=',
				'onDelete'        : '&',
				'disableSave'     : '=',
				'minimumTagLimit' : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'category', Category );
} )( );
